import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { FeedLoadAction } from '../../domains/feedLoad/actions.types';

import { GroupFeedsLastVisited } from './types';

export type GroupFeedLastVisitedAction = FeedLoadAction;

const initialState: GroupFeedsLastVisited = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupFeedsLastVisited, GroupFeedLastVisitedAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupFeedsLastVisited);
    default:
      return state;
  }
};

export default reducer;
